import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';
import moment from 'moment';

import {message, Tag } from 'antd';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function () {

    }
}

const headers = utils.columns([
    { key: '$index', label: '序号', width: 60 },
    { key: 'orgName', label: '部门', width: 100 },
    { key: 'userCode', label: '教师工号', width: 100 },
    { key: 'userName', label: '教师', width: 100 },
    { key: 'courseName', label: '课程名称', width: 150 },
    {key:'auditState1', label: '系部教学科审核', width: 120, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>预提交</Tag>)},
    { key: 'auditUserName1', label: '系教学科审核人', width: 120 },
    {key:'auditState2', label: '系部主任审核', width: 120, render:(d) => (+d === 1 ? <Tag color='#722ed1'>待审核</Tag> : +d === 2 ? <Tag color='#52c41a'>审核通过</Tag> : +d === 3 ? <Tag color='#f5222d'>审核不通过</Tag> : <Tag color='#1890ff'>预提交</Tag>)},
    { key: 'auditUserName2', label: '系主任审核人', width: 120 },
    { key: 'termName', label: '学期名称', width: 120 },
    { key: 'createTime', label: '报名日期', width: 100, render: (value) => value ? moment(new Date(value)).format('YYYY/MM/DD') : "" },
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('graduation/form/audit/query', Object.assign(defaultsParams, keywords))
        .then(response => {
            return {
                // headers: utils.columns(columns),
                headers: headers,
                data: response.payload.data,
            };
        })
        .then(res => (Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data.dataList || []).length ? '' : '暂无数据...'
        })));
}


/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const save = (data) => {
    return fetch.post('graduation/form/audit/save', data)
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const getSelection = () => {
    return DataGrid.selections;
}

const getSelectionData = () => {
    return DataGrid.selectData;
}

/**
 * 数据导出
 * @method exportList
 * @param {object} [keywords]
 * @return {promise}
 */
const exportList = (keywords) => {
    return fetch.download('graduation/form/audit/export', keywords, "课堂认证信息数据导出.xls")
}

/**
 * @method batchBack
 * @return {promise}
 */
const batchBack = (callback) => {
    return fetch.post('graduation/form/audit/batch/back', {ids: DataGrid.selections, auditType: 1})
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
        }

        callback();
        return response;
    });
}

export default {
    save,
    querySearch,
    headers,
    onSelect,
    onSelectData,
    setRefresh,
    getSelection,
    getSelectionData,
    exportList,
    batchBack
}